// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturesItems_container__2OqYY","img":"FeaturesItems_img__10Y3K","title":"FeaturesItems_title__3RIBU","desc":"FeaturesItems_desc__2iZDH"};